import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./assets/logo.png";

const Header = ({ onOpenWaitlist }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isProductPage = location.pathname === "/product";
  const isFAQPage = location.pathname === "/faq";
  const isCaseStudiesPage = location.pathname === "/case-studies";

  const linkClasses = (isActive) =>
    `text-sm sm:text-base font-bold py-2 px-1 relative transition-colors
     after:absolute after:left-0 after:bottom-0 after:h-0.5 after:bg-jindo-orange
     after:transition-all after:duration-300
     ${
       isActive
         ? "text-jindo-orange after:w-full"
         : "text-black hover:text-jindo-orange after:w-0 hover:after:w-full"
     }`;

  return (
    <header className="bg-gray-100 border-b border-gray-200/50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Jindo Logo" className="h-8 sm:h-10 w-auto" />
          </Link>
          <div className="flex items-center gap-4 sm:gap-6">
            <Link to="/" className={linkClasses(isHomePage)}>
              Home
            </Link>
            <Link to="/product" className={linkClasses(isProductPage)}>
              Product
            </Link>
            <Link to="/case-studies" className={linkClasses(isCaseStudiesPage)}>
              Case Studies
            </Link>
            <Link to="/faq" className={linkClasses(isFAQPage)}>
              FAQ
            </Link>
            <button
              onClick={onOpenWaitlist}
              className="inline-flex items-center justify-center rounded-full bg-black text-white px-2 sm:px-6 py-2 sm:py-3 font-bold text-xs sm:text-[15px] leading-none shadow-lg relative z-10"
            >
              Join the waitlist
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;